import React, { useCallback, useState, useEffect } from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Icon,
  Button,
  Hidden,
  Drawer,
} from '@material-ui/core'
import * as R from 'ramda'
import clsx from 'clsx'
import ConversationList from 'app/components/conversations/ConversationList'
import ConversationRoom from 'app/main/messages/conversations/ConversationRoom'
import { useConversation } from 'app/main/messages/conversations/useConversation'
import {
  useConversationSocket,
  ActionType,
} from 'app/main/messages/conversations/useConversationSocket'
import PersonAvatar from 'app/components/PersonAvatar'
import Assets from 'app/configs/assetConfigs'
import ErrorFetchingLoading from 'app/main/messages/notificationTimeline/ErrorFetchingLoading'
import { FormattedMessage, useIntl } from 'react-intl'
import DialogEditSubscribers from 'app/main/subscriber/components/dialogs/DialogEditSubscribers'
import { isOrdinaryGroup } from 'commons/groupLogic'
import effects from 'app/effects/effects'
import { EDIT_SUBSCRIBERS_REQUEST } from 'app/main/subscriber/constants'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import styles from 'app/main/messages/conversations/styles'
import * as Actions from 'app/store/actions/conversation.actions'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'
import { ConversationStatus } from 'app/main/messages/conversations/useConversation'
import { getAvatarPlaceHolder, isStartWithEng } from 'libs/text'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import crmLogic from 'app/main/subscriber/components/crm/crmLogic'
import CrmDialogsList from 'app/main/subscriber/components/crm/CrmDialogsList'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import LargeToolbar from 'app/components/LargeToolbar'
import { useFlag } from '@unleash/proxy-client-react'
import ConversationComingSoon from './ConversationComingSoon'

const MAX_WIDTH_CHAT_ROOM_ICON = 200
const EDIT_SUBSCRIBER_DIALOG = 'isOpenEditSubscriberDialog'

const withTagsId = R.over(
  R.lensProp('tags'),
  R.compose(
    R.map(R.prop('id')),
    R.filter(R.compose(isOrdinaryGroup, R.prop('group'))),
  ),
)

export default (props) => {
  const classes = styles()
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const [isOnline] = useIsOnline()

  const [
    {
      conversationData,
      isLoading,
      fetchErrorList,
      loadMore,
      hasMore,
      removeConversation,
    },
    refetchConversation,
  ] = useConversation()

  let initialState = {
    [EDIT_SUBSCRIBER_DIALOG]: false,
    formRestrictionLevel: 0,
  }

  const [state, setState] = useState(initialState)
  const [showConversationRoom, setShowConversationRoom] = useState(false)
  const [isShowItemAction, setIsShowItemAction] = useState(false)
  const [isShowPanelAction, setIsShowPanelAction] = useState(false)
  const [conversationSelected, setConversationSelected] = useState(null)
  const [currentHistoryId, setCurrentHistoryId] = useState(null)
  const [showList, onShowList] = useState(false)

  const mes_4386_dashbooard_chats_coming_soon = useFlag(
    'mes_4386_dashbooard_chats_coming_soon',
  )

  const {
    handleSendMessage,
    resendMessage,
    deleteMessage,
    chatRoomData,
    isChatLoading,
    fetchErrorChat,
    dispatchConversationSocket,
    refetchConversationRoom,
    loadMoreMessage,
    lastKey,
    socket,
    isLoadingMore,
    makeArchive,
    makeDelete,
    translateMessage,
    showOriginalMessage,
  } = useConversationSocket(conversationSelected)

  useEffect(() => {
    return () => {
      dispatch(Actions.clearConversationList())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket])

  let openOrCloseMoreActs = (bool) =>
    setIsShowItemAction(bool !== undefined ? bool : !isShowItemAction)

  let openOrClosePanelActs = (bool) =>
    setIsShowPanelAction(bool !== undefined ? bool : !isShowPanelAction)

  const openConversationRoom = (value, index) => {
    value['itemIndex'] = index
    dispatchConversationSocket({
      type: ActionType.CLEAR_DATA,
    })
    dispatch(Actions.updateHistoryId(value.historyId))
    dispatch(Actions.updateBadgeConversationList(value))
    setCurrentHistoryId(value.historyId)
    setConversationSelected(value)
    setShowConversationRoom(true)
    onShowList(false)
    openOrCloseMoreActs(false)
    openOrClosePanelActs(false)
  }

  const editSubscribers = () => {
    toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
  }

  const apiFetchersCallback = useCallback((fetchType, params) => {
    let fetch = () => effects.apis.updateSubscriber(params)
    if (fetchType === 'CONVERSATION_DELETE') {
      fetch = () => effects.apis.conversationsArchive(params)
    }

    return fetch()
  }, [])

  const editSubscriberRequest = (data) => {
    delete data.avatar
    return apiFetchersCallback(EDIT_SUBSCRIBERS_REQUEST, data)
      .then(() => {
        toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
      })
      .catch((error) => {
        toggleDialogs(EDIT_SUBSCRIBER_DIALOG, false)
        dispatch(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }

  function toggleDialogs(dialogType, isOpen, extraProps = undefined) {
    let newState = { ...state, [dialogType]: isOpen }
    if (dialogType === EDIT_SUBSCRIBER_DIALOG && extraProps) {
      if (extraProps.countryCode) {
        newState['editSubscriberData'] = extraProps
      } else {
        newState['editSubscriberData'] = {
          ...extraProps,
          countryCode: '+1',
        }
      }
    }
    if (isOpen) {
      newState['editSubscriberData'] = withTagsId(
        newState['editSubscriberData'],
      )
    }

    setState(newState)
  }

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => refetchConversation()} />
  }

  if (fetchErrorList) {
    return (
      <div className="mt-128">
        <ErrorFetchingLoading
          isShow={fetchErrorList}
          onLoadSuccess={refetchConversation}
          title={formatMessage({ id: 'error.general.title' })}
        />
      </div>
    )
  }

  const deletedPlaceholderText = formatMessage({
    id: 'conversation.subscriberDeleted.placeholder',
  })

  function conversationSelectedFirstName(conversationSelected) {
    const isDeleted = R.propEq(
      'conversationStatus',
      ConversationStatus.SUBSCRIBER_DELETED,
      conversationSelected,
    )
    if (isDeleted) {
      return deletedPlaceholderText
    }
    return R.compose(
      R.join(' '),
      R.filter(R.complement(R.isNil)),
    )([
      R.prop('firstName', conversationSelected),
      R.prop('lastName', conversationSelected),
    ])
  }

  function emptyAndClose(index = undefined) {
    openOrCloseMoreActs(false)

    dispatchConversationSocket({
      type: ActionType.CLEAR_DATA,
    })
    dispatch(Actions.updateHistoryId(null))
    dispatch(Actions.updateBadgeConversationList(null))
    setCurrentHistoryId(null)
    setConversationSelected(null)
    setShowConversationRoom(false)
    onShowList(true)
  }

  let handelArchive = (index) => {
    makeArchive(index).then(() => {
      removeConversation(index)
    })
    emptyAndClose(index)
  }

  let handelDelete = (index) => {
    makeDelete(index).then(() => {
      removeConversation(index)
    })
    emptyAndClose(index)
  }

  let displayListByType = (fetchedType) => {
    emptyAndClose()
    openOrClosePanelActs(false)
    dispatch(Actions.refetchConversation({ fetchedType }))
  }

  const SUBSCRIBER_DETAILS_DIALOG = 'isOpenDetailsDialog'
  const SUBSCRIBER_EDIT_DETAILS_DIALOG = 'isOpenEditDetailsDialog'
  const SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA =
    'isOpenMembershipCardDialogData'
  const SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA =
    'isOpenMembershipCardListDialogData'
  const SUBSCRIBER_APPROVE_DIALOG = 'isOpenApproveDialog'
  const SUBSCRIBER_REJECT_DIALOG = 'isOpenRejectDialog'

  const [localState, setLocalState] = useState({
    subscriber: {},
    [SUBSCRIBER_DETAILS_DIALOG]: false,
    [SUBSCRIBER_EDIT_DETAILS_DIALOG]: false,
    [SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA]: undefined,
    [SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA]: undefined,
    [SUBSCRIBER_APPROVE_DIALOG]: false,
    [SUBSCRIBER_REJECT_DIALOG]: false,
  })

  let crmObj = crmLogic({
    localState,
    setLocalState,
  })

  let openCrmModal = (data) => {
    if (data.subscriberId) {
      crmObj.openOrCloseDetailsDialog(data.subscriberId)
      openOrCloseMoreActs(false)
    }
  }

  const chat_2025_dashboard_menu_navigation = useFlag(
    'chat_2025_dashboard_menu_navigation',
  )

  const managerWebHostname = process.env.REACT_APP_MANAGER_WEB_HOSTNAME
  if (chat_2025_dashboard_menu_navigation && managerWebHostname) {
    window.location.replace(`${managerWebHostname}/chats`)
    return null
  }

  return (
    <ContentToolbarPage
      isFitViewPort
      contentToolbar={
        <LargeToolbar
          content={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navigation.chats.label" />
              </Typography>
            </>
          }
        />
      }
      content={
        <div className={clsx(classes.root)}>
          <div className={clsx(classes.contentCardWrapper, 'container')}>
            <div className={classes.contentCard}>
              <Hidden mdUp>
                <Drawer
                  className="h-full absolute z-20"
                  variant="temporary"
                  anchor="left"
                  open={showList}
                  onClose={() => onShowList(false)}
                  classes={{
                    paper: clsx(
                      classes.drawerPaper,
                      'absolute ltr:ltr:left-0 rtl:right-0 rtl:right-0',
                    ),
                  }}
                  style={{ position: 'absolute' }}
                  ModalProps={{
                    keepMounted: true,
                    disablePortal: true,
                    BackdropProps: {
                      classes: {
                        root: 'absolute',
                      },
                    },
                  }}
                >
                  <ConversationList
                    data={conversationData}
                    isLoading={isLoading}
                    currentHistoryId={currentHistoryId}
                    onClickListItem={openConversationRoom}
                    loadMore={loadMore}
                    hasMore={hasMore}
                  />
                </Drawer>
              </Hidden>
              <Hidden smDown>
                <Drawer
                  className="h-full z-20"
                  variant="permanent"
                  open
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                >
                  <div className={classes.headerConversationsAction}>
                    <MoreVertIcon
                      className={classes.moreIcon}
                      onClick={() => openOrClosePanelActs()}
                    />
                    {isShowPanelAction && (
                      <div className={classes.moreWrapper}>
                        <div
                          className={classes.moreItem}
                          onClick={() => displayListByType('active')}
                        >
                          <FormattedMessage id="conversations.active.label" />
                        </div>
                        <div
                          className={classes.moreItem}
                          onClick={() => displayListByType('archived')}
                        >
                          <FormattedMessage id="conversations.archived.label" />
                        </div>
                        <div
                          className={clsx(classes.moreItem, 'disabled')}
                          onClick={() => displayListByType('unsubscribed')}
                        >
                          <FormattedMessage id="conversations.unsubscribed.label" />
                        </div>
                      </div>
                    )}
                  </div>

                  <ConversationList
                    data={conversationData}
                    isLoading={isLoading}
                    currentHistoryId={currentHistoryId}
                    onClickListItem={openConversationRoom}
                    loadMore={loadMore}
                    hasMore={hasMore}
                  />
                </Drawer>
              </Hidden>
              <main className={clsx(classes.contentWrapper, 'z-10')}>
                {!showConversationRoom ? (
                  mes_4386_dashbooard_chats_coming_soon ? (
                    <ConversationComingSoon />
                  ) : (
                    <div className="flex flex-col flex-1 items-center justify-center p-24">
                      <img
                        src={Assets.conversation.chatRoomIcon}
                        width={MAX_WIDTH_CHAT_ROOM_ICON}
                        alt="chat"
                      />
                      <Button
                        variant="outlined"
                        color="primary"
                        className="flex md:hidden normal-case"
                        onClick={() => onShowList(true)}
                      >
                        Select a contact to start a conversation!..
                      </Button>
                    </div>
                  )
                ) : (
                  <React.Fragment>
                    <AppBar
                      color="default"
                      className="w-full"
                      position="static"
                      elevation={1}
                    >
                      <Toolbar className="md:px-16 px-0">
                        <div className={classes.headerPanel}>
                          <IconButton
                            color="inherit"
                            aria-label="Open ChevronLeft"
                            className="flex md:hidden"
                            onClick={() => {
                              onShowList(true)
                            }}
                          >
                            <Icon>chevron_left</Icon>
                          </IconButton>
                          {R.prop('subscriberId')(conversationSelected) ? (
                            <div className="flex items-center">
                              <div className="relative ltr:ml-8 rtl:mr-8 ltr:mr-12 rtl:ml-12">
                                <div className="absolute ltr:right-0 rtl:left-0 bottom-0 -m-4 z-10"></div>
                                <PersonAvatar
                                  placeHolder={
                                    isStartWithEng(
                                      R.prop('firstName')(conversationSelected),
                                    ) &&
                                    isStartWithEng(
                                      R.prop('lastName')(conversationSelected),
                                    )
                                      ? getAvatarPlaceHolder(
                                          R.prop('firstName')(
                                            conversationSelected,
                                          ),
                                          R.prop('lastName')(
                                            conversationSelected,
                                          ),
                                        )
                                      : null
                                  }
                                  subId={R.prop('subscriberId')(
                                    conversationSelected,
                                  )}
                                  src={conversationSelected.avatar}
                                  alt="avatar"
                                />
                              </div>
                              <Typography
                                color="inherit"
                                className="text-18 font-600"
                              >
                                {`${conversationSelected.firstName} ${conversationSelected.lastName}`}
                              </Typography>
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <div className="relative ltr:ml-8 rtl:mr-8 ltr:mr-12 rtl:ml-12">
                                <div className="absolute ltr:right-0 rtl:left-0 bottom-0 -m-4 z-10"></div>
                                <Avatar
                                  src={conversationSelected.avatar}
                                  alt="Avatar profile"
                                ></Avatar>
                              </div>
                              <Typography
                                color="inherit"
                                className="text-18 font-600"
                              >
                                {conversationSelectedFirstName(
                                  conversationSelected,
                                )}
                              </Typography>
                            </div>
                          )}

                          <div className={classes.headerActionPanel}>
                            <MoreVertIcon
                              className={classes.moreIcon}
                              onClick={() => openOrCloseMoreActs()}
                            />
                            {isShowItemAction && (
                              <div className={classes.moreWrapper}>
                                <div
                                  className={classes.moreItem}
                                  onClick={() =>
                                    handelDelete(
                                      conversationSelected['itemIndex'],
                                    )
                                  }
                                >
                                  <FormattedMessage id="conversations.delete.label" />
                                </div>
                                <div
                                  className={classes.moreItem}
                                  onClick={() =>
                                    handelArchive(
                                      conversationSelected['itemIndex'],
                                    )
                                  }
                                >
                                  <FormattedMessage id="conversations.makeArchive.label" />
                                </div>
                                {!mes_4386_dashbooard_chats_coming_soon && (
                                  <div
                                    className={clsx(
                                      classes.moreItem,
                                      conversationSelected.subscriberId
                                        ? ''
                                        : 'disabled',
                                    )}
                                    onClick={() =>
                                      openCrmModal(conversationSelected)
                                    }
                                  >
                                    <FormattedMessage id="conversations.viewInfo.label" />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </Toolbar>
                    </AppBar>
                    <div className={classes.content}>
                      <ConversationRoom
                        className="flex flex-1 z-10"
                        conversationSelected={conversationSelected}
                        chatRoomData={chatRoomData}
                        isLoading={isChatLoading}
                        handleSendMessage={handleSendMessage}
                        resendMessage={resendMessage}
                        deleteMessage={deleteMessage}
                        translateMessage={translateMessage}
                        fetchErrorChat={fetchErrorChat}
                        refetchConversationRoom={refetchConversationRoom}
                        dispatchConversationSocket={dispatchConversationSocket}
                        loadMoreMessage={loadMoreMessage}
                        lastKey={lastKey}
                        isLoadingMore={isLoadingMore}
                        showOriginalMessage={showOriginalMessage}
                      />
                    </div>
                  </React.Fragment>
                )}
              </main>
            </div>
          </div>
          {state[EDIT_SUBSCRIBER_DIALOG] && (
            <DialogEditSubscribers
              state={state}
              setState={setState}
              classes={classes}
              editSubscriberRequest={editSubscriberRequest}
              editSubscribers={editSubscribers}
              toggleDialogs={toggleDialogs}
              EDIT_SUBSCRIBER_DIALOG={EDIT_SUBSCRIBER_DIALOG}
            />
          )}

          <CrmDialogsList
            localState={localState}
            approveOrReject={crmObj.approveOrReject}
            openOrCloseDetailsDialog={crmObj.openOrCloseDetailsDialog}
            openOrCloseEditDetailsDialog={crmObj.openOrCloseEditDetailsDialog}
            updateCrmFields={crmObj.updateCrmFields}
            openMembershipCardDialog={crmObj.openMembershipCardDialog}
            closeMembershipCardDialog={crmObj.closeMembershipCardDialog}
            closeMembershipCardListDialog={crmObj.closeMembershipCardListDialog}
            openMembershipCardDetailDialog={
              crmObj.openMembershipCardDetailDialog
            }
            openMembershipCardListDialog={crmObj.openMembershipCardListDialog}
            isHideGroup={true}
          />
        </div>
      }
    />
  )
}
